module.exports = __webpack_public_path__ + "static/media/pool.7986f03d.jpeg";